import {useRouter} from 'next/router';
import type {FC} from 'react';
import {useMemo} from 'react';
import {useIndustryCategories} from '../../../../../../../core/repositories/reportsRepository';
import {cn} from '../../../../../../../lib/classname';
import {
  COLUMNS_COMPANY_LIST,
  extractColumnsCompanyListParams,
} from '../../../routes';
import {Taxonomies} from '../Taxonomies';

type Props = {
  className?: string;
};
export const CompanyFilterByIndustry: FC<Props> = ({className}) => {
  const {asPath} = useRouter();
  const queryString = useMemo(
    () => (asPath.includes('?') ? asPath.split('?')[1] : ''),
    [asPath],
  );
  const queryParams = useMemo(
    () => extractColumnsCompanyListParams(new URLSearchParams(queryString)),
    [queryString],
  );

  const {data} = useIndustryCategories({});

  const items = useMemo(() => {
    const industries = data?.ok ? data.value.industryCategories : [];
    return industries.map((industry) => ({
      id: industry.id,
      name: industry.name,
      href: COLUMNS_COMPANY_LIST({
        ...queryParams,
        industryId:
          industry.id === queryParams.industryId ? undefined : industry.id,
      }),
    }));
  }, [data, queryParams]);

  const activeIndex = useMemo(
    () => items.findIndex((item) => item.id === queryParams.industryId),
    [items, queryParams.industryId],
  );

  return (
    <div className={cn(className)}>
      <Taxonomies items={items} activeIndex={activeIndex} />
    </div>
  );
};
